<template>
  <tutorial-layout
    title="Watchers"
    :referenceLinks="referenceLinks"
    :youtubeLinks="youtubeLinks"
  >
    <p slot="overview">
      Watcher (or watch properties) is a generic way to observe and react to
      data changes on a Vue instance. Basically, watchers are doing very similar
      job as computed properties - they react to a change. But the difference in
      use is that computed properties are designed to return a value, and
      watchers are better to use to execute actions or for more complex
      operations (async updates, blocks refresh, etc.)
    </p>
    <p slot="benefits"> 
      <ul>
        <li>
          On a single data change - we can perform multiple and complex operations.
        </li>
        <li>
          Watcher can get value before change and after the change.
        </li>
      </ul>
    </p>
    <!-- <AndriiWatcher /> -->

    <v-card color="#f6f7ff">
      <v-card-text>
        <MeterConversion />
      </v-card-text>
    </v-card>
    <br/>

    <v-card color="#f6f7ff">
      <v-card-text>
        <WatcherUsage />
      </v-card-text>
    </v-card>
    <br/>
    
    <v-card color="#f6f7ff">
      <v-card-text>
        <ComputedWatcher />
      </v-card-text>
    </v-card>
  </tutorial-layout>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";
import MeterConversion from "./meter-conversion";
import ComputedWatcher from "../Computed/computed-watcher";
import WatcherUsage from "./watcher-usage";
// import AndriiWatcher from "./andrii-watcher";
export default {
  name: "VModel",
  mixins: [uiView],
  created() {},
  data: () => ({
    
  }),
  components: { tutorialLayout, ComputedWatcher, MeterConversion, WatcherUsage },
  props: {},
  watch: {
    
  },
  computed: {
    referenceLinks() {
      return [
        {
          title: "VueJs Watcher",
          href: "https://flaviocopes.com/vue-watchers/",
        },
        {
          title: "Vue Watch and WatchEffect",
          href:
            "https://learnvue.co/2019/12/a-simple-vue-watcher-tutorial-for-beginners/",
        },
        {
          title: "Vue Watch Property",
          href: "https://www.tutorialspoint.com/vuejs/vuejs_watch_property.htm",
        },
      ];
    },
    youtubeLinks() {
      return [
        {
          title: "What you need to know!",
          href: "https://www.youtube.com/embed/OEitxLemE_g",
        },
        {
          title: "Watchers for beginners",
          href: "https://www.youtube.com/embed/gJRqA3-2iWQ",
        },
        {
          title: "Computed properties & Watcher",
          href: "https://www.youtube.com/embed/2KU6DEnfNWo",
        },
      ];
    },
  },
  methods: {
    
  },
};
</script>
<style lang="scss"></style>
